<template>
  <div>
    <VTextField
      v-model="names[selectedLang]"
      :label="`${$t('forms.labels.name')} (${$t(`langs.${selectedLang}`)})`"
      :rules="{ required: selectedLang === teamMainLang, min: 1, max: 200 }"
      data-cy="category-text-name"
      outlined
      @input="updateData"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';

export default {
    components: {
        VTextField,
    },
    props: {
        category: {
            type: Object,
            default: () => ({}),
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            names: {},
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
            'teamMainLang',
            'selectedLang',
        ]),
    },
    watch: {
        data: {
            handler() {
                this.$emit('sendData', this.names);
            },
            deep: true,
        },
    },
    created() {
        if (this.isEdition) {
            this.names = this.category.name;
        }
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.names);
        },
    },
};
</script>
